module.exports = __webpack_public_path__ + "assets/img/scan.1009888b.png";